import {
    setCookie,
    initializeMap,
    initMenuTrigger,
    initOpenInNewTab,
    aosConfig,
    addScollClass,
    addParalax,
    addFancyboxFixForGallery,
    addCloseCookies,
    initForm,
    googleMapInit,
    initLoadNews
} from './functions';



import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);


const mainApp = () => {



    // init menu trigger
    initMenuTrigger();

    // init open in new tab
    initOpenInNewTab();

    // init AOS animation config
    aosConfig();

    // add scroll class to body  
    addScollClass('0px');

    // add paralax to element
    addParalax('.paralax');



    //fix gallery id for slideshow
    addFancyboxFixForGallery('.blocks-gallery-grid');

    // add close function to cookies
    addCloseCookies();



    //start - contact form
    initForm();

    googleMapInit();


    initLoadNews();




}

document.addEventListener("DOMContentLoaded", mainApp, false);


(function ($) {
    const mainAppWithJquery = () => {

        (function () {
            // menu hover
            let activeMenu = $(' .mainHeader .current-page-ancestor, .mainHeader .current_page_item');
            if (activeMenu.length == 0) {
                activeMenu = $(' .mainHeader__logo');
            }
            const activeWidth = (activeMenu.width() + activeMenu.offset().left) / $(window).width();
            let tweenBack = gsap.to('.mainHeader__menuHover', { duration: 1, scaleX: activeWidth, ease: "power3.out" });
            $('.mainHeader__menu > .menu > .menu-item, .mainHeader__logo').mouseenter(function () {
                tweenBack.pause();
                const ofWidth = ($(this).width() + $(this).offset().left) / $(window).width();
                gsap.to('.mainHeader__menuHover', {
                    duration: 1, scaleX: ofWidth,
                    ease: "power3.out"
                });
            }).mouseout(function () {
                tweenBack = gsap.to('.mainHeader__menuHover', { duration: 1, delay: 0.4, scaleX: activeWidth, ease: "power3.out" });
            });
        })();

        $('.subpageHeader__scroll').click(() => {
            gsap.to(window, { duration: 1, scrollTo: { y: $('.subpageHeader').height() - 100, x: 0 }, ease: "power3.out" });
        });

        gsap.fromTo('.subpageHeader__breadcrumbs, .subpageHeader__titleSmall,.subpageHeader__title, .subpageHeader__moreHolder', {
            delay: 0.5,
            opacity: 0,
            x: 50,

        }, {
            duration: 2,
            opacity: 1,
            x: 0,
            stagger: 0.3,
            ease: "power3.out",
        });


        if (!!window.IntersectionObserver && document.querySelector('.gpWind')) {


            let stickyMenuObserver = new IntersectionObserver(entries => {
                // console.log(entries[0]);
                if (entries[0].intersectionRatio == 0) {
                    document.body.classList.add('stickyMenu');
                } else {
                    document.body.classList.remove('stickyMenu');
                }
            });
            stickyMenuObserver.observe(document.querySelector('.subpageHeader'));


        }

        if (document.querySelector('.gpWind')) {



            const scrollActive = (i) => {
                let target = 'section' + i;
                $('.gpMenu__itrmA').removeClass('active');
                $('.gpMenu__itrmA[data-href=' + target + ']').addClass('active');
            };
            for (let i = 1; i < 6; i++) {

                if (document.querySelector('#scrollTarget_section' + i)) {

                    ScrollTrigger.create({
                        trigger: "#scrollTarget_section" + i,
                        start: "top center",
                        end: "bottom center",
                        onEnter: () => scrollActive(i),
                        onEnterBack: () => scrollActive(i),
                    });

                }

            }
            $('.goToSection3').click(function () {
                $('.gpMenu__itrmA[data-href=section3]').click();
            });
            $('.goToSection4').click(function () {
                $('.gpMenu__itrmA[data-href=section4]').click();
            });
        }


        $('.gpMenu__itrmA').click(function () {
            $('.gpMenu__itrmA').removeClass('active');
            $(this).addClass('active');
            const targetName = $(this).data('href');

            const targetOffset = $('#scrollTarget_' + targetName);

            gsap.to(window, { duration: 1, scrollTo: { y: targetOffset.offset().top - 100, x: 0 }, ease: "power3.out" });
        });


        //rotator and sliders
        /*  if ($('.rotatorTop').length > 0) {
              $('.rotatorTop').slick({
                  infinite: true,
                  arrows: true,
                  dots: true,
                  autoplay: true,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  speed: 500,
                  autoplaySpeed: 5000,
                  fade: true,
                  cssEase: 'linear'
              });
              var currentRotSlide = 0;
              $('.rotatorTop').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                  currentRotSlide = currentSlide;
                  $('.rotatorTop .rotator__slide:nth-child(' + (currentSlide + 1) + ')').addClass('slick-out');
              });
              $('.rotatorTop').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                  $('.rotatorTop .rotator__slide:nth-child(' + (currentRotSlide + 1) + ')').removeClass('slick-out');
              });
          }
  
          if ($('.rotatorText').length > 0) {
              $('.rotatorText').slick({
                  infinite: true,
                  arrows: true,
                  dots: true,
                  autoplay: true,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  speed: 500,
                  autoplaySpeed: 10000,
                  fade: true,
                  cssEase: 'linear'
              });
              var currentRotSlideText = 0;
              $('.rotatorText').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                  currentRotSlideText = currentSlide;
                  $('.rotatorText .rotator__slide:nth-child(' + (currentSlide + 1) + ')').addClass('slick-out');
              });
              $('.rotatorText').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                  $('.rotatorText .rotator__slide:nth-child(' + (currentRotSlideText + 1) + ')').removeClass('slick-out');
              });
          }
          if ($('.rotatorGallery').length > 0) {
              $('.rotatorGallery').slick({
                  infinite: true,
                  arrows: true,
                  dots: false,
                  autoplay: true,
                  speed: 500,
                  autoplaySpeed: 10000,
                  variableWidth: true,
                  centerMode: true
              });
              $('.rotatorGallery .slick-list').attr('id', 'gallery0');
          }*/

        if ($('.wp-block-gallery').length > 0) {
            $('.wp-block-gallery').each(function (i) {
                let newGallery = $('<div class="newGallery"><h3 class="newGallery__header">' +
                    $(this).find('.blocks-gallery-caption').text() +
                    '</h3><div  class="newGallery__slider slickSliderUi"></div></div>');
                let tempItem = '';
                $(this).find('.blocks-gallery-item figure, .wp-block-image').each(function (index) {
                    let newItem = $('<div class="newGallery__slide">' + $(this).html() + '</div>');
                    newItem.append(tempItem);
                    newGallery.find('.newGallery__slider').append(newItem);
                    tempItem = '';

                });
                $(this).before(newGallery);
                var idGal = 'gal' + (Math.floor(Math.random() * 100));
                newGallery.find('a').each(function () {
                    $(this).attr('data-fancybox', idGal);
                    $(this).attr('data-caption', $(this).next('figcaption').text());
                    $(this).find('img').removeAttr('loading');
                });
                $(this).remove();

            });



        }

        $('.newGallery__slider').slick({
            infinite: false,
            arrows: true,
            dots: false,
            autoplay: true,
            speed: 500,
            autoplaySpeed: 10000,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });




        //fancybox
        $(".blocks-gallery-item a, .fancybox, .wp-block-image a").fancybox({
            'loop': true,
            'margin': [44, 0],
            'gutter': 50,
            'keyboard': true,
            'arrows': true,
            'infobar': false,
            'toolbar': true,
            'buttons': ["slideShow", "fullScreen", "close"],
            'idleTime': 4,
            'protect': false,
            'modal': false,
            'animationEffect': "fade",
            'animationDuration': 600,
            'transitionEffect': "fade",
            'transitionDuration': 800,
        });



    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);



